/**
 * ****************************************************************************
 * @description     :   UserHeaderDropdown
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import React from "react";
import { Dropdown } from "react-bootstrap";

/**
 * Component for dropdown will show when click on avatar of user on right of header
 * -----------------------------------------
 * @author : create
 * @access : public
 */
const UserHeaderDropdown = () => {
    return (
        <Dropdown as="li" className="user-dropdown">
            <Dropdown.Toggle as="a" className="mr-n1">
                <div className="user-toggle">
                    <div className="user-avatar sm">
                        <em className="icon ni ni-user-alt" />
                    </div>
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-md dropdown-menu-right">
                <Dropdown.Item
                    as="div"
                    className="user-card-wrap bg-lighter d-none d-md-block"
                    bsPrefix="dropdown-inner"
                >
                    <div className="user-card">
                        <div className="user-avatar">
                            <span>AB</span>
                        </div>
                        <div className="user-info">
                            <span className="lead-text">お客様さん</span>
                            <span className="sub-text">user@mail.com</span>
                        </div>
                    </div>
                </Dropdown.Item>
                <Dropdown.Item as="div" bsPrefix="dropdown-inner">
                    <ul className="link-list">
                        <li>
                            <a href="javascript:void(0);">
                                <em className="icon ni ni-user-alt" />
                                <span>プロフィール</span>
                            </a>
                        </li>
                    </ul>
                </Dropdown.Item>
                <Dropdown.Item as="div" bsPrefix="dropdown-inner">
                    <ul className="link-list">
                        <li>
                            <a href="javascript:void(0);">
                                <em className="icon ni ni-signout" />
                                <span> ログアウト</span>
                            </a>
                        </li>
                    </ul>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default React.memo(UserHeaderDropdown);
